// ─── Chart Color Utilities ────────────────────────────────────────────────────

/**
 * Возвращает цвет из радужного градиента по HSL.
 * Используется для раскраски аптек на диаграммах и чипах таблицы.
 */
export function rainbowColor(index: number, total: number): string {
  const t = total <= 1 ? 0 : index / (total - 1);
  return `hsl(${Math.round(t * 270)}, 78%, 50%)`;
}

// ─── Category Colors ──────────────────────────────────────────────────────────

interface CategoryColorResult {
  bg: string;
  text: string;
}

/**
 * Возвращает цвета (фон + текст) для чипа категории товара.
 * Нераспознанные категории получают нейтральный серый цвет.
 */
export function getCategoryColor(cat: string): CategoryColorResult {
  if (cat === 'Медикаменты New') return { bg: 'rgba(37,99,235,0.08)', text: 'rgb(37,99,235)' };
  if (cat === 'БАД New') return { bg: 'rgba(13,148,136,0.08)', text: 'rgb(13,148,136)' };
  if (cat === 'Сангигиена NEW') return { bg: 'rgba(217,119,6,0.08)', text: 'rgb(217,119,6)' };
  return { bg: 'rgba(100,116,139,0.08)', text: 'rgb(100,116,139)' };
}
